import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	optionStatisticIssueCount: {
		id: 'software-burnup-report.common.option-statistic-issue-count',
		defaultMessage: 'Issue count',
		description: 'Issue count estimation label for burnup filters',
	},
	optionStatisticStoryPoints: {
		id: 'software-burnup-report.common.option-statistic-story-points',
		defaultMessage: 'Story points',
		description: 'Story points estimation label for burnup filters',
	},
	optionStatisticOriginalEstimate: {
		id: 'software-burnup-report.common.option-statistic-original-estimate',
		defaultMessage: 'Original estimate (Hours)',
		description: 'Original estimate label for burndown filters',
	},
	time: {
		id: 'software-burnup-report.common.time',
		defaultMessage: 'Date',
		description: 'Date axis label',
	},
	colLabelDate: {
		id: 'software-burnup-report.common.col-label-date',
		defaultMessage: 'Date',
		description: 'Label for the date column',
	},
	colLabelSummary: {
		id: 'software-burnup-report.common.col-label-summary',
		defaultMessage: 'Summary',
		description: 'Label for the summary column',
	},
	colLabelKey: {
		id: 'software-burnup-report.common.col-label-key',
		defaultMessage: 'Key',
		description: 'Label for the issue key column',
	},
	colLabelIssueType: {
		id: 'software-burnup-report.common.col-label-issue-type',
		defaultMessage: 'Issue type',
		description: 'Label for the issue type column',
	},
	colLabelEpic: {
		id: 'software-burnup-report.common.col-label-epic',
		defaultMessage: 'Epic',
		description: 'Label for the epic column',
	},
	colLabelScopeChangeDetails: {
		id: 'software-burnup-report.common.col-label-scope-change-details',
		defaultMessage: 'Details of scope change',
		description: 'Label for the scope change details column',
	},
	colLabelEstimationChange: {
		id: 'software-burnup-report.common.col-label-estimation-change',
		defaultMessage: 'Change in estimation',
		description: 'Label for the estimation change column',
	},
	colLabelStoryPoints: {
		id: 'software-burnup-report.common.col-label-story-points',
		defaultMessage: 'Story points',
		description: 'Label for the story points column',
	},
	colLabelIssueCount: {
		id: 'software-burnup-report.common.col-label-issue-count',
		defaultMessage: 'Issue count',
		description: 'Label for the issue count column',
	},
	colLabelStatus: {
		id: 'software-burnup-report.common.col-label-status',
		defaultMessage: 'Status',
		description: 'Label for the issue status column',
	},
	colLabelAssignee: {
		id: 'software-burnup-report.common.col-label-assignee',
		defaultMessage: 'Assignee',
		description: 'Label for the issue assignee column',
	},
});
